const mapElement = document.querySelector(".js-projects-map"),
    mapOverlay = document.querySelector(".js-projects-map-overlay"),
    projectTitle = document.querySelector(".js-project-title"),
    projectDescription = document.querySelector(".js-project-description"),
    projectType = document.querySelector(".js-project-type"),
    projectLocation = document.querySelector(".js-project-location-text"),
    projectStatus = document.querySelector(".js-project-status"),
    projectUrl = document.querySelectorAll(".js-project-url"),
    projectImage = document.querySelector(".js-project-image"),
    closeMapOverlay = document.querySelector(".js-close-projects-map-overlay"),
    openMap = document.querySelector(".js-open-map"),
    closeMap = document.querySelector(".js-close-map"),
    mapSection = document.querySelector(".js-map-section"),
    subNav = document.querySelector(".js-map-subnav")
    ;

let map,
    overlays = [],
    markers = [],
    allMarkers;

    openMap.addEventListener("click", () => {
        mapSection.classList.add("section--projects-map--active");
        body.classList.add('stop-scrolling');
        mapSection.style.height = window.innerHeight - header.offsetHeight + "px";
        // mapElement.style.height = window.innerHeight - header.offsetHeight + "px";
        google.maps.event.trigger(map, 'resize');
    });

    window.addEventListener("resize", () => {
        // console.log('window is resizing');
        mapSection.style.height = window.innerHeight - header.offsetHeight + "px";
        // mapElement.style.height = window.innerHeight - header.offsetHeight + "px";
        google.maps.event.trigger(map, 'resize');
    });

    closeMap.addEventListener("click", () => {
        mapSection.classList.remove("section--projects-map--active");

        allMarkers = document.querySelectorAll(".projects-map__marker");
        allMarkers.forEach((mrkr) => {
            mrkr.classList.remove("projects-map__marker--active");
        });
        mapOverlay.classList.remove("projects-map__overlay--active");
        body.classList.remove('stop-scrolling');
    });


    closeMapOverlay.addEventListener("click", () => {
        allMarkers = document.querySelectorAll(".projects-map__marker");
        allMarkers.forEach((mrkr) => {
            mrkr.classList.remove("projects-map__marker--active");
        });
        mapOverlay.classList.remove("projects-map__overlay--active");
        gsap.to(projectImage, 0.3, {
            autoAlpha: 0,
            ease: Power1.easeInOut
        });
    });

    


google.maps.event.addDomListener(window, "load", initialize);

let showLatLng = new google.maps.LatLng(51.5287718, -0.2416804);

function initialize() {
    const mapOptions = {
        zoom: 3,
        center: showLatLng,
        disableDefaultUI: true,
        zoomControl: true,
        backgroundColor: "#e9e9e9",
        styles: [
            {
                featureType: "administrative",
                elementType: "all",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "administrative",
                elementType: "labels.text.fill",
                stylers: [{ color: "#444444" }]
            },
            {
                featureType: "administrative.country",
                elementType: "geometry",
                stylers: [
                    { visibility: "on" },
                    { color: "#f7f7f7" },
                    { weight: "0.5" }
                ]
            },
            {
                featureType: "administrative.country",
                elementType: "geometry.fill",
                stylers: [
                    { weight: "0.01" },
                    { visibility: "off" },
                    { saturation: "-11" }
                ]
            },
            {
                featureType: "administrative.country",
                elementType: "labels",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "administrative.country",
                elementType: "labels.text",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "administrative.country",
                elementType: "labels.text.fill",
                stylers: [{ color: "#868686" }]
            },
            {
                featureType: "administrative.province",
                elementType: "labels",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "administrative.locality",
                elementType: "labels",
                stylers: [{ visibility: "on" }, { color: "#868686" }]
            },
            {
                featureType: "administrative.locality",
                elementType: "labels.text.stroke",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "administrative.neighborhood",
                elementType: "all",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "administrative.neighborhood",
                elementType: "labels",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "administrative.land_parcel",
                elementType: "geometry",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "landscape",
                elementType: "all",
                stylers: [{ color: "#e32525" }, { visibility: "off" }]
            },
            {
                featureType: "landscape",
                elementType: "geometry",
                stylers: [{ visibility: "on" }, { color: "#e3e3e3" }]
            },
            {
                featureType: "landscape.natural.landcover",
                elementType: "geometry",
                stylers: [{ color: "#e7e7e7" }]
            },
            {
                featureType: "landscape.natural.terrain",
                elementType: "geometry",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "poi",
                elementType: "all",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "poi.attraction",
                elementType: "geometry",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "poi.business",
                elementType: "geometry",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "poi.business",
                elementType: "geometry.fill",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "poi.business",
                elementType: "geometry.stroke",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "poi.business",
                elementType: "labels",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "poi.business",
                elementType: "labels.text",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "poi.business",
                elementType: "labels.text.fill",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "poi.business",
                elementType: "labels.text.stroke",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "poi.business",
                elementType: "labels.icon",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "poi.government",
                elementType: "all",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "poi.medical",
                elementType: "all",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "poi.park",
                elementType: "all",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "poi.place_of_worship",
                elementType: "all",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "poi.school",
                elementType: "all",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "poi.sports_complex",
                elementType: "all",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "road",
                elementType: "all",
                stylers: [{ saturation: -100 }, { lightness: 45 }]
            },
            {
                featureType: "road",
                elementType: "geometry",
                stylers: [
                    { gamma: "0.00" },
                    { weight: "0.01" },
                    { visibility: "off" }
                ]
            },
            {
                featureType: "road",
                elementType: "geometry.fill",
                stylers: [{ color: "#e9e9e9" }]
            },
            {
                featureType: "road.highway",
                elementType: "all",
                stylers: [{ visibility: "simplified" }]
            },
            {
                featureType: "road.highway",
                elementType: "labels",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "road.highway",
                elementType: "labels.text",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "road.highway.controlled_access",
                elementType: "geometry",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "road.arterial",
                elementType: "labels.icon",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "transit",
                elementType: "all",
                stylers: [{ visibility: "off" }]
            },
            {
                featureType: "water",
                elementType: "all",
                stylers: [{ color: "#f7f7f7" }, { visibility: "on" }]
            }
        ]
    };

    map = new google.maps.Map(mapElement, mapOptions);

    processData();
}

function processData() {
    // let bounds = new google.maps.LatLngBounds();

    $.getJSON(
        "/wp-content/themes/most/phpScripts/project-json.php",
        function (data) {
            $.each(data, function (i, post) {
                const title = post.title,
                    link = post.permalink,
                    latitude = post.location.lat,
                    longitude = post.location.lng,
                    description = post.description,
                    type = post.type,
                    locationText = post.locationText,
                    status = post.status,
                    image = post.image;

                if (latitude && longitude) {
                    const markerLatLng = new google.maps.LatLng(
                        latitude,
                        longitude
                    );

                    const marker = new google.maps.Marker({
                        map: map,
                        position: markerLatLng,
                        icon: "/wp-content/themes/most/static/build/images/marker-hidden.png",
                        clickable: false
                    });

                    markers.push(marker);

                    // bounds.extend(markerLatLng);
                    // map.fitBounds(bounds);

                    overlays.push(
                        new CustomMarker(markerLatLng, map, {
                            marker_title: title,
                            marker_link: link,
                            marker_description: description,
                            marker_type: type,
                            marker_locationText: locationText,
                            marker_status: status,
                            marker_image: image
                        })
                    );
                }
            });
        }
    )
        .done(function () {})
        .fail(function () {
            //console.log( "error" );
        })
        .always(function () {
            //console.log( "complete" );

            //$mapLoader.fadeOut();
            //show_markers();

            new MarkerClusterer(map, overlays, {
                imagePath: "/wp-content/themes/most/static/build/images/m"
            });
        });
}

function CustomMarker(latlng, map, args) {
    this.latlng = latlng;
    this.args = args;
    this.setMap(map);
}

CustomMarker.prototype = new google.maps.OverlayView();

CustomMarker.prototype.draw = function () {
    const self = this;
    let div = this.div;

    if (!div) {
        div = this.div = document.createElement("div");
        div.className = "projects-map__marker";

        const text = document.createTextNode(self.args.marker_title);
        div.appendChild(text);

        //var thisPos = this.latlng;

        google.maps.event.addDomListener(div, "click", function () {
            google.maps.event.trigger(self, "click");

            allMarkers = document.querySelectorAll(".projects-map__marker");
            allMarkers.forEach((mrkr) => {
                mrkr.classList.remove("projects-map__marker--active");
            });

            div.classList.add("projects-map__marker--active");

            mapOverlay.classList.add("projects-map__overlay--active");

            // map.panTo(thisPos);
            // if (map.getZoom()<8) { map.setZoom(8); }

            gsap.to(projectImage, 0.3, {
                autoAlpha: 0,
                ease: Power1.easeInOut
            });

            projectTitle.textContent = self.args.marker_title;
            projectDescription.innerHTML = self.args.marker_description;
            projectType.textContent = self.args.marker_type;
            projectLocation.textContent = self.args.marker_locationText;
            projectStatus.textContent = self.args.marker_status;
            projectUrl.forEach(url => {
                url.href = self.args.marker_link;
            })
            
            

            if (self.args.marker_image) {
                projectImage.src = self.args.marker_image;
                projectImage.alt = self.args.marker_title;
                imagesLoaded(mapOverlay, function () {
                    gsap.to(projectImage, 0.3, {
                        autoAlpha: 1,
                        ease: Power1.easeInOut
                    });
                });
            }
        });

        const panes = this.getPanes();
        panes.overlayImage.appendChild(div);
    }

    const point = this.getProjection().fromLatLngToDivPixel(this.latlng);

    if (point) {
        div.style.left = point.x - 16 + "px";
        div.style.top = point.y - 16 + "px";
    }
};

CustomMarker.prototype.getDraggable = function () {};

CustomMarker.prototype.getPosition = function () {
    return this.latlng;
};

CustomMarker.prototype.onRemove = function () {
    if (this.div) {
        this.div.style.visibility = "hidden";
    }
};

CustomMarker.prototype.onAdd = function () {
    if (this.div) {
        this.div.style.visibility = "visible";
    }
};

